import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { GenesysService } from './services/genesys-service/genesys.service';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil, filter, switchMap } from 'rxjs/operators';
import { UserService } from './services/user-service/user.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'sat-frontend';
  isAuthorized = false;

  private destroy$ = new Subject<void>();

  constructor(
    private genesysService: GenesysService,
    private route: ActivatedRoute,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    this.genesysService.isAuthorized
      .pipe(takeUntil(this.destroy$))
      .subscribe(isAuth => (this.isAuthorized = isAuth));

    combineLatest([
      this.route.queryParams,
      this.genesysService.isAuthorized
    ])
      .pipe(
        takeUntil(this.destroy$),
        filter(([_, isAuth]) => !isAuth),
        switchMap(() => this.genesysService.initialize()),
        switchMap(() => this.genesysService.getUserMe())
      )
      .subscribe(result => {
        console.log(result?.name);
        const currentUser = {
          id: result?.id,
          name: result?.name,
          email: result?.email,
          division: result?.division
        }
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        this.userService.notifyUserUpdate(); // Notifiez le changement
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
